import $http from '@/config/http'
import { setHttpData } from '@config/makeRequest'
import dataTable from '@config/dataTable'

//获取服务器时间
export const getServerTime = () => {
  return new Promise((resolve, reject) => {
    $http.post('', { domain: 'cdel', resourcePath: '+/server/time' })
      .then(res => {
        const { data } = res
        if (data.success) {
          resolve(data.result)
        } else {
          reject({ msg: '获取服务器时间失败' })
        }
      }).catch(() => {
      reject({ msg: '获取服务器时间失败' })
    })
  })
}

// 获取公匙
export const getPublicKey = () => {
  return new Promise((resolve, reject) => {
    $http.post('/', {
      params: {
        time: (new Date).getTime()
      },
      domain: 'cdel',
      resourcePath: '+/key/public',
      platform: '',
      appType: '',
      appVersion: ''
    })
      .then(res => {
        const { data } = res
        if (data.success) {
          resolve(data.result)
        } else {
          reject({ msg: '获取公钥失败' })
        }
      })
      .catch(() => {
        reject({ msg: '获取公钥失败' })
      })
  })
}
//---------------------------------------------
//获取类别和辅导集合
export const getCategoryMajors = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/getCategoryMajors',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '获取辅导失败' })
        }
      }).catch(() => {
      reject({ msg: '获取辅导失败' })
    })
  })
}
//获取试卷列表
export const getPapers = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/getPapers',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '获取试卷列表失败' })
        }
      }).catch(() => {
      reject({ msg: '获取试卷列表失败' })
    })
  })
}
//获取做题记录列表
export const getRecords = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/getRecords',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '获取做题记录列表失败' })
        }
      }).catch(() => {
      reject({ msg: '获取做题记录列表失败' })
    })
  })
}
//获取收藏列表记录
export const getFavs = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/getFavs',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '获取收藏列表失败' })
        }
      }).catch(() => {
      reject({ msg: '获取收藏列表失败' })
    })
  })
}
//获取收藏记录对应的类别和辅导
export const getFavCategoryMajors = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/getFavCategoryMajors',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '获取收藏记录类别失败' })
        }
      }).catch(() => {
      reject({ msg: '获取收藏记录类别失败' })
    })
  })
}
//取消收藏
export const deleteFavQues = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/deleteFavQues',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '取消收藏失败' })
        }
      }).catch(() => {
      reject({ msg: '取消收藏失败' })
    })
  })
}

//添加收藏
export const addFavQues = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/addFavQues',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '添加收藏失败' })
        }
      }).catch(() => {
      reject({ msg: '添加收藏失败' })
    })
  })
}
